export default "__VITE_ASSET__BfiHKfAE__"